import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_exemption_terms_accurate_current_valid_and_followed_by_the'

export const dataPointDefinition = {
  retracedId: 'are_exemption_terms_accurate_current_valid_and_followed_by_the',
  name: 'Are exemption terms accurate, current, valid and followed by the facility?',
  description:
    'The intent of this question is to understand if the terms within the actual exemption are accurate, current and valid. And that the terms are being followed (adhered to) by the facility. \r\r\n\r\r\nFor example, if the exemption specified that the total working hours must not exceed 480 total hours for a three-month period for a worker, but at least one worker worked more than 480 hours during this period, answer No.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wh-6--2',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 6730,
  sectionId: '2.2.12',
  impactArea: 'Working Hours',
  impactAreaId: 'WORKING_HOURS_AND_OVERTIME',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
